import React, {useEffect, useState} from "react"
import classNames from "classnames";
import _ from "lodash";
import { usePrevious } from "../../../../hooks";
import { CheckCircleFilled } from "@ant-design/icons";
import { renderInfoTip } from "../helper";

const getMainStepStatus = (step, returnMoreInfo) => {
  if(step.steps) {
    if(step.steps.every( s => s.status == 'wait')) 
      return 'wait'
    else if(step.steps.every( s => s.status == 'finish'))
      return 'finish'
    else 
      return 'process'
  } else {
    return returnMoreInfo ? (step.status + ' single-step') : step.status; 
  }
}

const getMainStepIcon = (status, i ) => {
  if(status === 'finish') {
    return <CheckCircleFilled />
  } 
  return i + 1
}

export const updateStepsDataFunction = (updatedStepsData, targetKey, fieldToUpdate, udpatedField) => {
  const stepsData = _.clone(updatedStepsData);
  let targetObject = null;

  stepsData.forEach((item) => {
    if (item.steps) {
      const stepIndex = item.steps.findIndex((step) => step.key === targetKey);
      if (stepIndex !== -1) {
        targetObject = item.steps[stepIndex];
      }
    } else if (item.key === targetKey) {
      targetObject = item;
    }
  });
  
  if (targetObject) {
    targetObject[fieldToUpdate] = udpatedField;
    if(fieldToUpdate == 'status') {
      if (targetObject.steps) {
        const stepIndex = targetObject.steps.findIndex((step) => step.title === targetKey);
        targetObject.steps[stepIndex] = { ...targetObject.steps[stepIndex], status: 'process' };
      } else {
        const itemIndex = stepsData.findIndex((item) => item.title === targetKey);
        stepsData[itemIndex] = targetObject;
      }
    }
  }
  return stepsData;
}

const SequentialLeftNav = (props) =>{
  const {stepsData, current, dontFinishCurrentYet, onChange} = props;
  const [steps, setSteps] = useState()
  const prevCurrent = usePrevious(current);

  const stepSetter = (updatedStepsData) => {
    const steps = [];
    updatedStepsData.forEach( (step, i) => {
    let icon = null;
    let label = null;

    if(step.label) {
      icon = <div className="icon-wrapper"><div className="icon">{getMainStepIcon(getMainStepStatus(step), i)}</div></div>
      label = <div className="title">{step.label}</div>
      let warningIcon = step.warning ? renderInfoTip("Changes Detected", "warning") : null;
      warningIcon = step.error ? renderInfoTip("Error(s) found", "error-icon") : warningIcon;
      steps.push(<div className={`main-step ${getMainStepStatus(step, true)} pointer`} onClick={() =>onChange(step.steps ? step.steps[0].key : step.key)}>{icon}{label}{warningIcon}</div>)
    }
    if(step.steps){
        step.steps.forEach((step, i)=> {
          let icon = <div className="icon-wrapper"><div className="icon"></div></div>;
          let label = <div className="title">{step.title}</div>
          let warningIcon = step.warning ? renderInfoTip("Changes Detected", "warning") : null;
          warningIcon = step.error ? renderInfoTip("Error(s) found", "error-icon") : warningIcon;
          steps.push(<div className={`sub-step ${step.status} pointer`}  onClick={() =>onChange(step.key)}>{icon}{label}{warningIcon}</div>)
        })
      }
    })
    setSteps(steps)
  }

  useEffect(()=>{
    let updatedStepsData = updateStepsDataFunction(stepsData, prevCurrent, 'status', dontFinishCurrentYet ? 'wait' : 'finish')
    updatedStepsData = updateStepsDataFunction(updatedStepsData, current, 'status', 'process')
    props.setStepsData(updatedStepsData);
    stepSetter(updatedStepsData)
  },[current]);

  useEffect(()=>{
    stepSetter(stepsData)
  },[stepsData]);

  return (
    <div className="sequential-navigation">
      {steps}
    </div>
  )
}

export default SequentialLeftNav;